export default __webpack_public_path__ + "static/media/logo_720.2a087637.png";